enum CheckoutInfoErrorType {
  InvalidCartItem = 'invalid_cart_item',
}

export default CheckoutInfoErrorType;
